import { forwardRef, useEffect, useState } from 'react';
import { styled } from '@mui/material/styles';
import { Button } from '@mui/material';
import { useAddCommentMutation } from '../../../../store/api/commentApi';
import { useSelector } from 'react-redux';
import { selectUser } from '../../../../store/auth/authSlice';
import { toast } from 'react-toastify';
import { useContext } from 'react';
import { AppContext } from '../../../../context/ContextProvider';

const MakeNotesContainer = styled('form')({
  boxSizing: 'border-box',
  display: 'flex',
  justifyContent: 'space-between',
  border: '2px solid #99989A',
  margin: '11px 3px 0',
  '& *': {
    fontFamily: 'Raleway',
    fontSize: '14px',
    lineHeight: '35px',
    height: '35px',
    border: 'none',
    background: 'none',
  },
});

const CommentInputBox = styled('input')({
  fontWeight: '400',
  color: '#000000',
  padding: '0 10px',
  width: 'calc(100% - 60px)',
  '&:focus': {
    outline: 'none',
  },
});

const SubmitBtn = styled(Button)({
  fontWeight: '700',
  color: 'rgba(170, 145, 120, 0.4)',
  padding: '0 11px',
  width: '60px',
  '&:hover': {
    color: 'rgba(170, 145, 120)',
  },
});

const MakeComment = forwardRef(({ noteId, commentData, clearCommentData }, ref) => {
  const { isShow, setIsShow, isLogin, setIsLogin } = useContext(AppContext);
  const [text, setText] = useState('');
  const [placeholderText, setPlaceholderText] = useState('Leave your comments...');
  const [isReply, setIsReply] = useState(false);
  const [addComment] = useAddCommentMutation();
  const { parentComment, replyToUserId, replyToUserName } = commentData;
  const currentUserId = useSelector(selectUser);

  const formSubmit = async (e) => {
    e.preventDefault();
    let commentApiData;
    if (isReply) {
      commentApiData = {
        noteId,
        body: {
          text,
          authorId: currentUserId,
          parentCommentId: parentComment,
          replyTo: replyToUserId,
        },
      };
    } else {
      commentApiData = {
        noteId,
        body: {
          text,
          authorId: currentUserId,
        },
      };
    }

    await addComment(commentApiData);
    setText('');
    clearCommentData();
  };
  const isBlock = !currentUserId || !isLogin;
  const clickToast = () => {
    if (isBlock) {
      toast.success('Please Sign in first.');
    }
    return;
  };

  useEffect(() => {
    if (commentData.replyToUserName) {
      setPlaceholderText(`Reply to ${replyToUserName}`);
      setIsReply(true);
    } else {
      setPlaceholderText('Leave your comments...');
      setIsReply(false);
    }
  }, [commentData]);

  return (
    <MakeNotesContainer onSubmit={formSubmit} onClick={clickToast}>
      <CommentInputBox
        type="text"
        placeholder={placeholderText}
        required
        value={text}
        onChange={(e) => setText(e.target.value)}
        ref={ref}
        disabled={isBlock}
      ></CommentInputBox>
      <SubmitBtn type="submit" disabled={isBlock}>
        Post
      </SubmitBtn>
    </MakeNotesContainer>
  );
});

export default MakeComment;
